import { render, staticRenderFns } from "./DashboardIsfpPsfpSerieTemporalIsfpTendencia.vue?vue&type=template&id=0b65e206&scoped=true&"
import script from "./DashboardIsfpPsfpSerieTemporalIsfpTendencia.vue?vue&type=script&lang=js&"
export * from "./DashboardIsfpPsfpSerieTemporalIsfpTendencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b65e206",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VCardTitle,VProgressCircular})
